export type SummaryResolution = "resolved" | "not resolved" | "transferred" | string | null;
